// extracted by mini-css-extract-plugin
export default {"balances":"BalancesByTutor_balances__ZXhCV","balancesItem":"BalancesByTutor_balancesItem__FrdC9"};